module.exports = __webpack_public_path__ + "img/selected_cabinet_on.ef99faa0.svg";